<!-- <div class="card-view loader">
    <img [src]="icon.credittLoader" alt="creditt loader" srcset="">
</div> -->

<div class="main-loader">
    <img [src]="icon.credittLoader" alt="loader" class="loader" />
</div>